import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import MakeAPICall from "../../apiCalls/common";

import APP_CONSTANTS from "../../constants";
import appRoutes from "../../routes/appRoutes";

import {
  getQueueOfDoctorApiRoute,
  changeBusyModeAdminApiRoute,
  logoutFromAdminApiRoute,
  endCallByDoctorFromAdminApiRoute
} from "../../apiRoutes";

import {
  updateTimer,
  deleteTimer
} from "../../reduxStore/actions/doctorsQueue";

import Loader from "../../components/loader";
import ICPhoneDisplay from "../../components/phoneDisplay";
import CustomDataTable from "../../components/datatable/customDataTable";
import CustomModal from "../../components/modal";
import RefreshButton from "../../components/refreshButton";
import DeviceDetails from "../../components/deviceDetails";
import TimerDisplay from "../../components/timerDisplay";

import ICNoImg from "../../assets/images/default-picture.png";

import { getFormattedTimeOnly } from "../../utils/dateTimeHelper";

const DoctorsInQueuePage = props => {
  let history = useHistory();
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [currSelItem, setCurrSelItem] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [doctorQueueList, setDoctorQueueList] = useState([]);
  const [dataBusyList, setDataBusyList] = useState([]);
  const [busyDoctorList, setBusyDoctorList] = useState([]);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showBusyModal, setShowBusyModal] = useState(false);
  const [showAvailableModal, setShowAvailableModal] = useState(false);
  const [showEndCallModal, setShowEndCallModal] = useState(false);
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");
  const [docInQueueCount, setDocInQueueCount] = useState(0);
  const [patientsInQueueCount, setPatientsInQueueCount] = useState(0);

  const [availableDoctors, setAvailableDoctors] = useState([]);
  const [busyDoctors, setBusyDoctors] = useState([]);
  const [connectedDoctors, setConnectedDoctors] = useState([]);

  const [doctorQueueTimer, setDoctorQueueTimer] = useState({});

  const tableHeaders = [
    {
      key: "No.",
      value: "No."
    },
    { key: "uni", value: "UIN" },
    { key: "profilePic", value: "Profile Pic", customStyle: { width: "88px" } },
    { key: "doctorDetails", value: "Doctor Details" },
    { key: "uin", value: "UIN" },
    { key: "profilePic", value: "Profile Pic", customStyle: { width: "88px" } },
    { key: "patientDetails", value: "Patient Details" },
    { key: "natureOfConsult", value: "Nature of Consult" },
    { key: "deviceDetails", value: "Patient Device Details" }
  ];

  // set each appointment timers
  const countAppointmentTimer = async (connectedDoctors) => {
    console.log("Now check the connected doctors: ", connectedDoctors);
    let queueTimerDataToSet = {};
    await connectedDoctors.forEach((queueData) => {
      console.log("Each Queue Data: ", queueData);
      const timerDataForQueue = {
        status: queueData.status,
        queueId: queueData._id
      };
      if (queueData.acceptedTime) {
        timerDataForQueue['acceptedTime'] = getFormattedTimeOnly(queueData.acceptedTime);
      }

      if (queueData.connectedTime) {
        timerDataForQueue['connectedTime'] = getFormattedTimeOnly(queueData.connectedTime);
      }


      console.log("Timer data: ", timerDataForQueue);
      queueTimerDataToSet[queueData._id] = timerDataForQueue;
    });
    console.log("Final Queue Timer Data To Set: ", queueTimerDataToSet);
    await setDoctorQueueTimer(queueTimerDataToSet);
  }

  console.log({availableDoctors, busyDoctors, connectedDoctors})

  // get queue list
  const getQueueList = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setIsProcessing(true);
    setApiCallParams({
      reqType: "GET",
      reqUrl: getQueueOfDoctorApiRoute,
      successCallback: async res => {

        // let doctorQueueData = [];
        // await res.data.data.availableDoctors.forEach((data, index) => {
        //   doctorQueueData.push(data);
        // });

        // await res.data.data.doctorsInQueueData.forEach((data, index) => {
        //   doctorQueueData.push(data);
        // })

        const totalDocCount = res.data.data.availableDoctors.available.length + res.data.data.doctorsInQueueData.length + res.data.data.availableDoctors.busy.length;
        setDocInQueueCount(totalDocCount);

        setAvailableDoctors(res.data.data.availableDoctors.available);
        setBusyDoctors(res.data.data.availableDoctors.busy);
        setConnectedDoctors(res.data.data.availableDoctors.connectedDoctors);

        console.log(availableDoctors, busyDoctors, connectedDoctors);

        // setDoctorQueueList(res.data.data.availableDoctors.available);
        // setDataBusyList(filtered);
        // setBusyDoctorList(res.data.data.availableDoctors.busy); // online but busy and not connected
        setTotalRecords(totalDocCount);
        // setDocInQueueCount(res.data.data.DoctorQueue.length + res.data.data.DataBusy.length);
        setPatientsInQueueCount(res.data.data.patientsInQueueCount || 0);

        countAppointmentTimer(res.data.data.doctorsInQueueData);
        // setInterval(() => {
        //   updateAppointmentTimers();
        // }, 1000);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };
  // const getQueueList = (event) => {
  //   if(event) {
  //     event.stopPropagation();
  //   }
  //   setIsProcessing(true);
  //   setApiCallParams({
  //     reqType: "GET",
  //     reqUrl: getQueueOfDoctorApiRoute,
  //     successCallback: async res => {
  //       var tempArr = res.data.data;

  //       await res.data.data.DoctorQueue.forEach((column, index) => {
  //         tempArr.DoctorQueue[index].queueNo = index + 1;
  //       });

  //       let custom = [];
  //       await res.data.data.BusyDoctor.forEach((column, index) => {
  //         custom[index] = column.doctorId;
  //       });

  //       let busyFilterArray = JSON.stringify(custom);

  //       let dataLenthArray = [];

  //       await res.data.data.DataBusy.forEach((column, index) => {
  //         if (busyFilterArray.indexOf(column._id) === -1) {
  //           dataLenthArray[index] = column;
  //         }
  //       });

  //       let filtered = await dataLenthArray.filter(function(el) {
  //         return el != null;
  //       });

  //       await filtered.forEach((column, index) => {
  //         filtered[index].queueNo =
  //           res.data.data.DoctorQueue.length + index + 1;
  //       });

  //       // get the current timers
  //       let currIntervals = props.doctorsQueueTimers;

  //       await res.data.data.BusyDoctor.forEach((column, index) => {
  //         tempArr.BusyDoctor[index].queueNo =
  //           res.data.data.DoctorQueue.length + filtered.length + index + 1;

  //         // if the call is now in connected state
  //         if (
  //           column.status === 4 ||
  //           (column.isPhoneCallUsed !== undefined &&
  //             column.isPhoneCallUsed === true)
  //         ) {
  //           // if the timer is not started then start it
  //           if (props.doctorsQueueTimers[column._id] === undefined) {
  //             startNewConsultTimer(column, 0);
  //           }
  //           // otherwise start it from the same point
  //           else {
  //             startNewConsultTimer(
  //               column,
  //               props.doctorsQueueTimers[column._id].startPoint || 0
  //             );
  //             // if the consult is still in progress then remove it from the curr timers list
  //             delete currIntervals[column._id];
  //           }
  //         }
  //       });

  //       // clear the ended appointment intervals
  //       for (let key in currIntervals) {
  //         deleteEndedConsultTimer(currIntervals[key]);
  //       }

  //       let totalEntries = 0;

  //       if (tempArr.DoctorQueue) {
  //         totalEntries = totalEntries + tempArr.DoctorQueue.length;
  //       }

  //       if (tempArr.BusyDoctor) {
  //         totalEntries = totalEntries + tempArr.BusyDoctor.length;
  //       }

  //       if (filtered) {
  //         totalEntries = totalEntries + filtered.length;
  //       }

  //       // there was a bug and quick fix for now ----
  //       let totalDoctorsIds = [];
  //       try {
  //         for (let i = 0; i < res.data.data.DoctorQueue.length; i++) {
  //           if (totalDoctorsIds.indexOf(res.data.data.DoctorQueue[i]._id) === -1) {
  //             totalDoctorsIds.push(res.data.data.DoctorQueue[i]._id);
  //           }
  //         }
  //         for (let i = 0; i < res.data.data.DataBusy.length; i++) {
  //           if (totalDoctorsIds.indexOf(res.data.data.DataBusy[i]._id) === -1) {
  //             totalDoctorsIds.push(res.data.data.DataBusy[i]._id);
  //           }
  //         }
  //         for (let i = 0; i < res.data.data.BusyDoctor.length; i++) {
  //           if (totalDoctorsIds.indexOf(res.data.data.BusyDoctor[i].doctorData[0]._id) === -1) {
  //             totalDoctorsIds.push(res.data.data.BusyDoctor[i].doctorData[0]._id);
  //           }
  //         }
  //       } catch (e) {
  //         console.log("Error during doctor count calculation: ", e);
  //       }
  //       setDocInQueueCount(totalDoctorsIds.length);
  //       // ------- over there was a bug and quick fix for now ----

  //       setDoctorQueueList(tempArr.DoctorQueue);
  //       setDataBusyList(filtered);
  //       setBusyDoctorList(tempArr.BusyDoctor);
  //       setTotalRecords(totalEntries);
  //       // setDocInQueueCount(res.data.data.DoctorQueue.length + res.data.data.DataBusy.length);
  //       setPatientsInQueueCount(res.data.data.patientsInQueue || 0);
  //       setIsProcessing(false);
  //     },
  //     failureCallback: err => {
  //       setIsProcessing(false);
  //       setErrModalText(
  //         "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
  //       );
  //       setShowErrModal(true);
  //     }
  //   });
  // };

  const getPatientsInQueueCount = (event) => {
    if(event) {
      event.stopPropagation();
    }
    setApiCallParams({
      reqType: "GET",
      reqUrl: getQueueOfDoctorApiRoute,
      successCallback: async res => {
        setPatientsInQueueCount(res.data.data.patientsInQueue || 0);
      },
      failureCallback: err => {
        console.log("Error in getPatientsInQueueCount in doctorsInQueuePage: ", err);
      }
    });
  }

  const gotoPatientsInQueue = () => {
    history.push(appRoutes.patientsInQueue);
  }

  // swtich doctor status
  const switchDoctorStatus = status => {
    setShowBusyModal(false);
    setShowAvailableModal(false);
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("doctorId", currSelItem._id);
    formData.append("isBusy", status);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: changeBusyModeAdminApiRoute,
      dataObj: formData,
      successCallback: async res => {
        setIsProcessing(false);
        await getQueueList();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
        getQueueList();
      }
    });
  };

  // logout selected doctor
  const logoutSelDoctor = () => {
    setShowLogoutModal(false);
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("doctorId", currSelItem.doctorId);

    setApiCallParams({
      reqType: "POST",
      reqUrl: logoutFromAdminApiRoute,
      dataObj: formData,
      successCallback: async res => {
        setIsProcessing(false);
        getQueueList();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
        getQueueList();
      }
    });
  };

  // end call
  const endSelItemCall = () => {
    setShowEndCallModal(false);
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("appointmentId", currSelItem.appointmentId);
    formData.append("callStatus", "COMPLETE");

    setApiCallParams({
      reqType: "PUT",
      reqUrl: endCallByDoctorFromAdminApiRoute,
      dataObj: formData,
      timeout: 30000,
      successCallback: async res => {
        setIsProcessing(false);
        getQueueList();
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setErrModalText("Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists.");
        //setShowErrModal(true);
        getQueueList();
      }
    });
  };

  useEffect(() => {
    getQueueList();
  }, []);

  const showSwitchDoctorBusyModal = data => {
    setCurrSelItem(data);
    setShowBusyModal(true);
  };

  const showSwitchDoctorOnlineModal = data => {
    setCurrSelItem(data);
    setShowAvailableModal(true);
  };

  const showDoctorLogoutModal = data => {
    setCurrSelItem(data);
    setShowLogoutModal(true);
  };

  const showSelEndCallModal = data => {
    setCurrSelItem(data);
    setShowEndCallModal(true);
  };

  const startNewConsultTimer = (data, startPoint) => {
    let startTimer = startPoint;
    startTimer++;
    let d = Number(startTimer),
      h = Math.floor(d / 3600),
      m = Math.floor((d % 3600) / 60),
      s = Math.floor((d % 3600) % 60),
      hDisplay = h > 0 ? h + (h === 1 ? " hour : " : " hours : ") : "",
      mDisplay = m > 0 ? m + (m === 1 ? " min : " : " mins : ") : "",
      sDisplay = s > 0 ? s + (s === 1 ? " sec" : " secs") : "";

    if (props.doctorsQueueTimers[data._id]) {
      // clear previous interval before starting a new one
      clearInterval(props.doctorsQueueTimers[data._id].intervalId);
    }

    let intervalId = setInterval(() => {
      startTimer++;
      let d = Number(startTimer),
        h = Math.floor(d / 3600),
        m = Math.floor((d % 3600) / 60),
        s = Math.floor((d % 3600) % 60);
      let hDisplay = h > 0 ? h + (h === 1 ? " hour : " : " hours : ") : "";
      let mDisplay = m > 0 ? m + (m === 1 ? " min : " : " mins : ") : "";
      let sDisplay = s > 0 ? s + (s === 1 ? " sec" : " secs") : "";

      props.updateTimer({
        _id: data._id,
        intervalId: intervalId,
        time: hDisplay + mDisplay + sDisplay,
        startPoint: startTimer
      });
    }, 1000);

    props.updateTimer({
      _id: data._id,
      intervalId: intervalId,
      time: hDisplay + mDisplay + sDisplay,
      startPoint: startTimer
    });
  };

  const deleteEndedConsultTimer = data => {
    clearInterval(data.intervalId);
    props.deleteTimer(data);
  };

  const setSelectedPatient = pat => {
    const auth = props.auth.user;
    window.open(
      APP_CONSTANTS.pmsURL +
        "/patient/patientDetails?accessToken=" +
        auth.accessToken +
        "&patientId=" +
        pat.id +
        "&searchType=" +
        auth.userType +
        "&adminName=" +
        auth.firstName +
        " " +
        auth.lastName,
      "_blank"
    );
  };

  return (
    <div className="view-ticket-container doctors-queue-page-container">
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showBusyModal}
        cancelEvent={() => {
          setShowBusyModal(false);
          setCurrSelItem(null);
        }}
        okayEvent={() => switchDoctorStatus(true)}
        modalBodyContent={
          <p className="text-center mb-0">
            Do you want to switch this doctor to busy?
          </p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showAvailableModal}
        cancelEvent={() => {
          setShowAvailableModal(false);
          setCurrSelItem(null);
        }}
        okayEvent={() => switchDoctorStatus(false)}
        modalBodyContent={
          <p className="text-center mb-0">
            Do you want to switch this doctor to available?
          </p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showLogoutModal}
        cancelEvent={() => {
          setShowLogoutModal(false);
          setCurrSelItem(null);
        }}
        okayEvent={logoutSelDoctor}
        modalBodyContent={
          <p className="text-center mb-0">Do you want to logout this doctor?</p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showEndCallModal}
        cancelEvent={() => {
          setShowEndCallModal(false);
          setCurrSelItem(null);
        }}
        okayEvent={endSelItemCall}
        modalBodyContent={
          <p className="text-center mb-0">Do you want to end this call?</p>
        }
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showErrModal}
        cancelEvent={() => {
          setShowErrModal(false);
          setErrModalText("");
          setCurrSelItem(null);
        }}
        modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
      />
      <div className="d-flex flex-row flex-wrap">
        <h3 className="mr-5">
          Doctors In Queue
          <RefreshButton onClick={getQueueList} />
          <span className="ml-1 font-19">
            ({docInQueueCount})
          </span>
        </h3>
        <div className="ml-4"></div>
        <h3 className="cursor-pointer ml-5" onClick={gotoPatientsInQueue}>
          Patients In Queue
          <RefreshButton onClick={(event) => getQueueList(event)} />
          <span className="ml-1 font-19">
            ({patientsInQueueCount})
          </span>
        </h3>
      </div>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <CustomDataTable
          disableFilterPagination={true}
          sortableTable={false}
          totalRecords={totalRecords}
          headers={tableHeaders}
        >
          {availableDoctors.map((item, index) => {
            let fullName = item.firstName + " ";
            if (
              item.middleName !== null &&
              item.middleName !== undefined &&
              item.middleName !== ""
            ) {
              fullName = fullName + item.middleName + " ";
            }

            fullName = fullName + item.lastName;

            return (
              <tr key={index} className="row-no-hover-effect">
                {/* <td>{item.queueNo}</td> */}
                <td>
                  <p>
                    {index + 1}
                  </p>
                </td>
                <td>{item.doctorId}</td>
                <td>
                  <div className="d-flex flex-column position-relative pb-4">
                  <div className="d-flex flex-column position-relative">

                    <img
                      // className="rounded-circle user-img"
                      className={`rounded-circle user-img`}
                      src={
                        item.profilePic === null ||
                        item.profilePic === undefined
                          ? ICNoImg
                          : item.profilePic.original
                      }
                      alt="user-img"
                    />
                    <i
                      onClick={() => showDoctorLogoutModal(item)}
                      className="fa fa-times fa-2x error exit-queue-icon"
                    ></i>
                    {item.isBusy === true && (
                      <div
                        onClick={() => showSwitchDoctorOnlineModal(item)}
                        className="doctor-busy-circle"
                      ></div>
                    )}
                    {item.isBusy === false && (
                      <div
                        onClick={() => showSwitchDoctorBusyModal(item)}
                        className="doctor-live-circle"
                      ></div>
                    )}

                  </div>
                  <div className="row access-level-icons">
                      {item.canTakeMedicareConsult && <p className="font-19 medicare-tick-color">✓</p>}
                    {item.isAccessToInstantSwitch && <p className="font-19" style={{ color: "#aaaaaa" }}>✓</p>}
                    {item.isAccessToInstantHush  && <p className="font-19" style={{ color: "#3892ea"}}>✓</p>}
                  </div>
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-column">
                    <p className="mb-0">
                      <b>{fullName}</b>
                    </p>
                    <a
                      className="high-z-index list-email"
                      href={"mailto:" + item.email}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.email}
                    </a>
                    <p className="mb-0">
                      <ICPhoneDisplay value={item.phoneNumber} />
                    </p>
                  </div>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            );
          })}


          {connectedDoctors.map((item, index) => {
            const queueNumber = availableDoctors.length + index + 1;
            let fullName = item.doctorId.firstName + " ";
            if (
              item.doctorId.middleName !== null &&
              item.doctorId.middleName !== undefined &&
              item.doctorId.middleName !== ""
            ) {
              fullName = fullName + item.doctorId.middleName + " ";
            }

            fullName = fullName + item.doctorId.lastName;

            let patientName = item.patientId.firstName + " ";
            if (
              item.patientId.middleName !== null &&
              item.patientId.middleName !== undefined &&
              item.patientId.middleName !== ""
            ) {
              patientName = patientName + item.patientId.middleName + " ";
            }

            patientName = patientName + item.patientId.lastName;

            return (
              <tr
                key={index}
                className={
                  "row-no-hover-effect BusyStatus-" +
                  item.status +
                  (item.directCall === true ? "direct" : "") +
                  (item.bookingCall === true ? "booked" : "") +
                  (item.isPhoneCallUsed === true ? " dr-phoneCalled" : "")
                }
              >
                <td>
                  <p>
                    {queueNumber} <br />
                    {/* {props.doctorsQueueTimers[item._id]
                      ? props.doctorsQueueTimers[item._id].time
                      : ""} */}
                  </p>
                  {
                    doctorQueueTimer[item._id] && doctorQueueTimer[item._id]['acceptedTime'] && (
                      <TimerDisplay time={doctorQueueTimer[item._id] ? doctorQueueTimer[item._id]['acceptedTime'] : ''} />
                    )
                  }
                </td>
                <td>{item.doctorId.doctorId}</td>
                <td>
                  <div className="d-flex flex-column position-relative pb-4">
                    <div className="d-flex flex-column position-relative">
                    <img
                      // className="rounded-circle user-img"
                      className={`rounded-circle user-img`}
                      src={
                        item.doctorId.profilePic === null ||
                          item.doctorId.profilePic === undefined
                          ? ICNoImg
                          : item.doctorId.profilePic.original
                      }
                      alt="user-img"
                    />
                  </div>
                  <div className="row access-level-icons">
                      {item.doctorId?.canTakeMedicareConsult && <p className="font-19 medicare-tick-color">✓</p>}
                    {item.doctorId?.isAccessToInstantSwitch && <p className="font-19" style={{ color: "#aaaaaa" }}>✓</p>}
                    {item.doctorId?.isAccessToInstantHush  && <p className="font-19" style={{ color: "#3892ea"}}>✓</p>}
                  </div>
                </div>
                </td>
                <td>
                  <div className="d-flex flex-column">
                    <p className="mb-0">
                      <b>{fullName}</b>
                    </p>
                    <a
                      className="high-z-index list-email"
                      href={"mailto:" + item.doctorId.email}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.doctorId.email}
                    </a>
                    <p className="mb-0">
                      <ICPhoneDisplay value={item.doctorId.phoneNumber} />
                    </p>
                  </div>
                </td>
                <td>
                  {" "}
                  <a
                    className="pat-pms-custom-link"
                    onClick={e => {
                      e.stopPropagation();
                      setSelectedPatient({
                        id: item.patientId._id
                      });
                    }}
                    href="#"
                  >
                    {item.patientId.patientId}
                  </a>
                </td>
                <td>
                  <div className="d-flex flex-column position-relative">
                    <img
                      className="rounded-circle user-img"
                      src={
                        item.patientId.profilePic === null ||
                          item.patientId.profilePic === undefined ||
                          item.patientId.profilePic === null
                          ? ICNoImg
                          : item.patientId.profilePic.original
                      }
                      alt="user-img"
                    />
                    <i
                      onClick={() => showSelEndCallModal(item)}
                      className="fa fa-times fa-2x error exit-queue-icon"
                    ></i>
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-column">
                    <p className="mb-0">
                      <b>{patientName}</b>
                    </p>
                    <a
                      className="high-z-index list-email"
                      href={"mailto:" + item.patientId.email}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.patientId.email}
                    </a>
                    <p className="mb-0">
                      <ICPhoneDisplay value={item.patientId.phoneNumber} />
                    </p>
                  </div>
                </td>
                <td>{item.consultId ? item.consultId.consultName : ""}</td>
                <td>
                  <DeviceDetails data={item.deviceDetails} />
                </td>
              </tr>
            );
          })}

          {busyDoctors.map((item, index) => {
            const queueNumber = availableDoctors.length + connectedDoctors.length + index + 1;
            let fullName = item.firstName + " ";
            if (
              item.middleName !== null &&
              item.middleName !== undefined &&
              item.middleName !== ""
            ) {
              fullName = fullName + item.middleName + " ";
            }

            fullName = fullName + item.lastName;

            return (
              <tr key={index} className="row-no-hover-effect">
                <td>{queueNumber}</td>
                <td>{item.doctorId}</td>
                <td>
                  <div className="d-flex flex-column position-relative pb-4">
                    <div className="d-flex flex-column position-relative">
                    <img
                      // className="rounded-circle user-img"
                      className={`rounded-circle user-img`}
                      src={
                        item.profilePic === null ||
                          item.profilePic === undefined
                          ? ICNoImg
                          : item.profilePic.original
                      }
                      alt="user-img"
                    />
                    <i
                      onClick={() => showDoctorLogoutModal(item)}
                      className="fa fa-times fa-2x error exit-queue-icon"
                    ></i>
                    {item.isBusy === true && (
                      <div
                        onClick={() => showSwitchDoctorOnlineModal(item)}
                        className="doctor-busy-circle"
                      ></div>
                    )}
                    {item.isBusy === false && (
                      <div
                        onClick={() => showSwitchDoctorBusyModal(item)}
                        className="doctor-live-circle"
                      ></div>
                    )}
                  </div>
                  <div className="row access-level-icons">
                      {item.canTakeMedicareConsult && <p className="font-19 medicare-tick-color">✓</p>}
                    {item.isAccessToInstantSwitch && <p className="font-19" style={{ color: "#aaaaaa" }}>✓</p>}
                    {item.isAccessToInstantHush  && <p className="font-19" style={{ color: "#3892ea"}}>✓</p>}
                  </div>
                </div>
                </td>
                <td>
                  <div className="d-flex flex-column">
                    <p className="mb-0">
                      <b>{fullName}</b>
                    </p>
                    <a
                      className="high-z-index list-email"
                      href={"mailto:" + item.email}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.email}
                    </a>
                    <p className="mb-0">
                      <ICPhoneDisplay value={item.phoneNumber} />
                    </p>
                  </div>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            );
          })}
        </CustomDataTable>
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  doctorsQueueTimers: state.doctorsQueueTimers.timers
});

const mapDispatchToProps = dispatch => ({
  updateTimer: data => dispatch(updateTimer(data)),
  deleteTimer: data => dispatch(deleteTimer(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(DoctorsInQueuePage);
